/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Theme info in console
console.log('Custom Shopify Theme Developed By EcomGraduates LLC | https://www.ecomgraduates.com')


// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors message - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
    errors.querySelector('ul').classList.add('mb-0')
}

// Detect scroll
window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        document.documentElement.classList.add('scrolled')
    } else {
        document.documentElement.classList.remove('scrolled')
    }
})

// Detect when element is within the scroll view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered')
                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

// Fix EnterView animations within Shopify Theme Editor
document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((enterViewEl) => {
        enterViewEl.classList.add('entered')
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0')
        })
    })
});

// Init Rrellax.js
(() =>
    new Rellax('.rellax', {
        center: true
    })
)()
